module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C829"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Tables ")]), _vm._v("and Figures ")])]), _vm._v(" "), _c('p', {
    staticClass: "P34"
  }, [_vm._v("TABLES ")]), _vm._v(" "), _c('table', {
    staticClass: "ill1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_CHAPTER#id_107"
    }
  }, [_vm._v("Table 1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_CHAPTER#id_107"
    }
  }, [_vm._v("Growth of African American population in Oakwood ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_CHAPTER#id_119"
    }
  }, [_vm._v("Table 2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_CHAPTER#id_119"
    }
  }, [_vm._v("Growth of Latino population in Venice and Oakwood ")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "P36"
  }, [_vm._v("FIGURES (MAPS AND PHOTOGRAPHS) ")]), _vm._v(" "), _c('table', {
    staticClass: "ill"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "P335"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_Introduc#id_8"
    }
  }, [_vm._v("Figure 1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "P335"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_Introduc#id_8"
    }
  }, [_vm._v("Map of Venice tour ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "P335"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_CHAPTER#id_75"
    }
  }, [_vm._v("Figure 2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "P335"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_CHAPTER#id_75"
    }
  }, [_vm._v("Oil derricks on the beach ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of the distribution of housing projects in Oakwood ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oakwood Recreation Center with Shoreline Crip tag ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oakwood alleyway ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972-1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Latino residents’ church and park routes ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 7")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#id_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fence surrounding a house ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gates in front of boardwalk businesses ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 9")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sponto Gallery ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 10")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RVs near Rose Avenue ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 11")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#id_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homeless encampment ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#id_285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#id_285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canal sidewalks prior to redevelopment ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#id_310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 13")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#id_310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canal cleanup campaign on empty lot ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#id_346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 14")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#id_346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scenic Venice Canals ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#id_363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 15")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#id_363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Venice Boardwalk scene ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#id_370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 16")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#id_370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Venice Beach carnival performer ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#id_409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 17")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#id_409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homeless performer ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 18")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abandoned storefront ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_444",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 19")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_444",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thrift shop ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 20")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-end shop mimicking thrift presentation ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_454",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 21")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "C972"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#id_454",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New artist lofts ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b704f44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_List_of.vue
// module id = 69
// module chunks = 0